import { NavItem } from '@/ui-components/pages/hooks/useLayout'
import { useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import { FaHome, FaThLarge, FaChartBar } from 'react-icons/fa'
import { useLocation } from 'react-router'
import { useNavigate } from 'react-router'

const useFooterBar = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const { t } = useTranslation()

  const navItems: NavItem[] = [
    {
      label: t('footer.home'),
      icon: <FaHome />,
      path: '/lotto',
      active: location.pathname === '/lotto',
      onClick: () => handleNavClick('/lotto'),
    },
    {
      label: t('footer.report'),
      icon: <FaThLarge />,
      path: '/lotto/poll',
      active: location.pathname === '/lotto/poll',
      onClick: () => handleNavClick('/lotto/poll'),
    },
    {
      label: t('footer.resulted'),
      icon: <FaChartBar />,
      path: '/lotto/result',
      active: location.pathname === '/lotto/result',
      onClick: () => handleNavClick('/lotto/result'),
    },
  ]

  const handleNavClick = useCallback(
    (path: string) => {
      navigate(path)
    },
    [navigate],
  )

  return { navItems, activePath: location.pathname, onNavClick: handleNavClick }
}
export default useFooterBar
